import React, {useEffect, useState} from "react";
import {apiClient} from "../../../../services/ApiClient";
import {
  Button,
  Dropdown,
  Input,
  Menu,
  message,
  PageHeader,
  Select,
  Space,
  Table,
  Modal, Switch, Tooltip
} from "antd";
import {DownOutlined, EditFilled, PlusOutlined, QuestionCircleOutlined, SettingOutlined} from "@ant-design/icons";
import moment from "moment";
import ServiceKaskoStatusEdit from "./ServiceKaskoStatusEdit";
import {windowService} from "../../../../services/WindowService";
import ServiceKaskoStatusSettingsDialog from "./ServiceKaskoStatusSettingsDialog";

const { Search, TextArea } = Input;
const { Option } = Select;

const FILTER_DUE_ALERT = "dueAlert";

export default function ServiceKaskoStatusPage({globalUpdate, alertsCount, notifyGlobalUpdate}) {
  let [update, setUpdate] = useState(0);
  let [loading, setLoading] = useState(false);
  let [records, setRecords] = useState([]);
  let [selected, setSelected] = useState(null);
  let [search, setSearch] = useState(null);
  let [selectedRecords, setSelectedRecords] = useState([]);
  let [commentedRecord, setCommentedRecord] = useState(null);
  let [selectedRecordsOperation, setSelectedRecordsOperation] = useState(null);
  let [owners, setOwners] = useState([]);
  let [selectedOwnerId, setSelectedOwnerId] = useState([]);
  let [ownersLoading, setOwnersLoading] = useState(false);
  let [regions, setRegions] = useState([]);
  let [selectedRegionId, setSelectedRegionId] = useState([]);
  let [vehicleGroups, setVehicleGroups] = useState([]);
  let [selectedGroupId, setSelectedGroupId] = useState(null);
  let [customFilter, setCustomFilter] = useState(null);
  let [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    setLoading(true);
    apiClient.getServiceKaskoStatusList({ regNumber: search, ownerId: selectedOwnerId, regionId: selectedRegionId, groupId: selectedGroupId, customFilter: customFilter})
      .then(res => {
        setRecords(res.records);
      })
      .catch(err => { message.error(err); })
      .finally(() => { setLoading(false); })
  }, [globalUpdate, update, search, selectedOwnerId, selectedRegionId, selectedGroupId, customFilter]);

  useEffect(() => {
    setOwnersLoading(true);
    apiClient.getVehicleOwners({"view": "minimal"})
      .then(res => {
        setOwners(res.records);
      })
      .catch(err => { message.error(err) })
      .finally(() => { setOwnersLoading(false);});

    apiClient.getRegions({"order": "title"})
      .then(res => { setRegions(res.records) })
      .catch(err => { console.error(err) });

    apiClient.getVehicleGroups({"order": "title"})
      .then(res => { setVehicleGroups(res.records) })
      .catch(err => { console.error(err) });
  }, [globalUpdate]);

  const executeSelectedRecordsOperation = operationKey => {
    setSelectedRecordsOperation({"key": operationKey});
  };

  return (
    <>
      <PageHeader
        className="site-page-header"
        title="КАСКО"
        extra={
          <div style={{textAlign: "right"}}>
            <Space>
              {
                alertsCount > 0
                  ? (
                    <>
                      <Switch
                        checkedChildren={<span>Со сроком оплаты: {alertsCount}</span>}
                        unCheckedChildren={<span>Со сроком оплаты: {alertsCount}</span>}
                        checked={customFilter === FILTER_DUE_ALERT}
                        onChange={(e) => {
                          e ? setCustomFilter(FILTER_DUE_ALERT) : setCustomFilter(null);
                          setSelectedRecords([]);
                        }}
                      />
                      <Tooltip
                        placement="top"
                        title="При выборе этого фильтра Вы увидите ТС, у которых приближается срок оплаты полиса"
                      >
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </>
                  ) : null
              }
              <span>{`Количество авто: ${records.length}`}</span>
              {
                selectedRecords.length > 0 && false
                  ? (
                    <>
                      <Dropdown
                        disabled={selectedRecords.length < 1}
                        overlay={(
                          <Menu onClick={(e) => { executeSelectedRecordsOperation(e.key); }}>

                          </Menu>
                        )}>
                        <Button style={{textAlign: "left"}}>
                          С выбранными <DownOutlined/>
                        </Button>
                      </Dropdown>
                    </>
                  ) : null
              }
              <Button type={"link"} icon={<SettingOutlined/>} style={{}}
                      onClick={() => {
                        setShowSettings(true);
                      }}>
                Настройки
              </Button>
            </Space>
          </div>
        }
      />

      <Space style={{margin: '10px 0'}}>
        <Search
          enterButton
          placeholder={"Поиск по гос.номеру"}
          onSearch={(value) => {
            setSearch(value)
          }}
          allowClear={true}
          style={{width: 400}}
        />
        <Select
          allowClear
          showSearch
          loading={ownersLoading}
          placeholder="Собственник"
          value={selectedOwnerId}
          style={{width: 300}}
          onChange={(data) => { setSelectedOwnerId(data); }}
          filterOption={(input, option) => {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        >
          {
            owners.map(el => <Option key={el.id} value={el.id}>{`${el.title}`}</Option>)
          }
        </Select>
        <Select
          allowClear
          mode="multiple"
          placeholder="Филиал"
          value={selectedRegionId}
          style={{width: 300}}
          onChange={(data) => { setSelectedRegionId(data); }}
          filterOption={(input, option) => {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        >
          {
            regions.map(el => <Option key={el.id} value={el.id}>{`${el.title}`}</Option>)
          }
        </Select>
        <Select
          allowClear
          placeholder="Группа"
          value={selectedGroupId}
          style={{width: 300}}
          onChange={(data) => { setSelectedGroupId(data); }}
        >
          {
            vehicleGroups.map(el => <Option key={el.id} value={el.id}>{`${el.title}`}</Option>)
          }
        </Select>
      </Space>
      <Table
        loading={loading}
        size={'small'}
        sticky
        scroll={{x: 1500}}
        columns={[
          {
            title: "",
            align: "center",
            width: 30,
          },
          Table.SELECTION_COLUMN,
          {
            title: '',
            width: 50,
            render: (text, record, index) => {
              return (
                <Space direction={"horizontal"}>
                  <Button
                    type="link"
                    icon={<EditFilled/>}
                    disabled={!record?.id}
                    onClick={() => {
                      setSelected(record);
                    }}
                  />
                </Space>
              )
            }
          },
          {
            title: 'Номер ТС',
            align: "center",
            render: (text, record, index) => {
              if(!record.car) {
                return "";
              }
              return (
                <Button
                  type={"link"}
                  onClick={() => {
                    windowService.openRouteWindow(`cp/park/vehicles/${record.car.id}`);
                  }}
                >
                  {
                    <>
                      <div>
                        {record.car.reg_number}
                      </div>
                    </>
                  }
                </Button>
              );
            }
          },
          {
            title: 'Марка/Модель',
            align: "center",
            render: (text, record, index) => {
              return `${record.car?.brand} ${record.car?.model}`;
            }
          },
          {
            title: 'Собственник',
            render: (text, record, index) => {
              return record.owner?.title;
            },
            sorter: (a, b) => {
              let aVal = a.owner?.title || "";
              let bVal = b.owner?.title || "";
              return aVal.localeCompare(bVal);
            },
          },
          {
            title: 'Страховщик',
            align: "center",
            render: (text, record, index) => {
              return `${record.kasko_company || ""}`;
            }
          },
          {
            title: '№ полиса',
            align: "center",
            render: (text, record, index) => {
              return `${record.kasko_number || ""}`;
            }
          },
          {
            title: 'Дата полиса',
            align: "center",
            dataIndex: 'kasko_issue_dt',
            render: (text, record, index) => {
              return record.kasko_issue_dt ? moment(record.kasko_issue_dt).format('DD.MM.YYYY'): "";
            },
            sorter: (a, b) => {
              let aVal = a.kasko_issue_dt ? moment(a.kasko_issue_dt).valueOf() : -1;
              let bVal = b.kasko_issue_dt ? moment(b.kasko_issue_dt).valueOf() : -1;
              return aVal - bVal;
            },
          },
          {
            title: 'Премия',
            align: "center",
            render: (text, record, index) => {
              return `${record.kasko_premium}`;
            }
          },
          {
            title: 'Франшиза',
            align: "center",
            render: (text, record, index) => {
              return `${record.kasko_deductible}`;
            }
          },
          {
            title: 'Дата окончания полиса',
            align: "center",
            dataIndex: 'kasko_due_dt',
            render: (text, record, index) => {
              return record.kasko_due_dt ? moment(record.kasko_due_dt).format('DD.MM.YYYY'): "";
            },
            sorter: (a, b) => {
              let aVal = a.kasko_due_dt ? moment(a.kasko_due_dt).valueOf() : -1;
              let bVal = b.kasko_due_dt ? moment(b.kasko_due_dt).valueOf() : -1;
              return aVal - bVal;
            },
          },
          {
            title: 'Дней до окончания полиса',
            align: "center",
            render: (text, record, index) => {
              return record.kasko_due_dt
                ? moment(record.kasko_due_dt).endOf('day').diff(moment(), 'days') + 1
                : "";
            },
            sorter: (a, b) => {
              let aVal = a.kasko_due_dt ? moment(a.kasko_due_dt).diff(moment(), 'days') : -1;
              let bVal = b.kasko_due_dt ? moment(b.kasko_due_dt).diff(moment(), 'days') : -1;
              return aVal - bVal;
            },
          },
          {
            title: 'Город',
            align: "center",
            render: (text, record, index) => {
              return record.region?.title;
            }
          },
          {
            title: 'Комментарий',
            dataIndex: 'comment',
            render: (text, record, index) => {
              const comment = (record.comment || "").trim();
              return comment.length > 0
                ? (
                  <div
                    onDoubleClick={() => {
                      record.__comment = record.comment;
                      setCommentedRecord(record);
                    }}
                  >{record.comment || ""}</div>
                ) : (
                  <div style={{textAlign: 'center'}}>
                    <Button type={"link"} icon={<PlusOutlined/>} onClick={() => {
                      record.__comment = record.comment;
                      setCommentedRecord(record);
                    }}/>
                  </div>
                )
            }
          },
          {
            title: "",
            align: "center",
            width: 20,
          }
        ]}
        dataSource={records}
        rowKey="id"
        pagination={{position: 'topRight', defaultPageSize: 50, pageSizeOptions: [25, 50, 75], hideOnSinglePage: true}}
        rowSelection={{
          columnWidth: '50px',
          type: 'checkbox',
          preserveSelectedRowKeys: true,
          selectedRowKeys: selectedRecords,
          onChange: (selectedRowKeys) => {
            setSelectedRecords(selectedRowKeys);
          }
        }}
      />
      {
        selected !== null
          ? (
            <ServiceKaskoStatusEdit
              visible={true}
              title={"Статус КАСКО"}
              item={selected}
              onOk={(record) => {
                apiClient.updateServiceKaskoStatus(record.id, record)
                  .then(res => {
                    setSelected(null);
                    setUpdate(prev => prev + 1)
                  })
                  .catch(err => { message.error(err); })
              }}
              onCancel={() => { setSelected(null); }}
            />
          ) : null
      }
      {
        commentedRecord !== null && (
          <Modal
            title="Комментарий"
            visible={true}
            onOk={() => {
              apiClient.updateServiceKaskoStatus(commentedRecord.id, {comment: commentedRecord.comment})
                .then(res => {
                  delete commentedRecord.__comment;
                  setCommentedRecord(null);
                })
                .catch(err => {
                  message.error(err);
                });
            }}
            onCancel={() => {
              commentedRecord.comment = commentedRecord.__comment;
              delete commentedRecord.__comment;
              setCommentedRecord(null);
            }}
          >
            <TextArea
              allowClear
              style={{width: '100%'}}
              rows={3}
              onChange={(e) => {
                commentedRecord.comment = e.target.value;
              }}
              defaultValue={commentedRecord.comment}
            />
          </Modal>
        )
      }
      {
        showSettings && (
          <ServiceKaskoStatusSettingsDialog
            onClose={() => {
              setShowSettings(false);
              notifyGlobalUpdate();
            }}
          />
        )
      }
    </>
  )

}